<template>
  <div>
    <v-layout column>
      <mensagem-anexo :parametro-id="parametroMensagemAnexo"></mensagem-anexo>
      <h4 class="subheading font-weight-black primary--text mt-2">Anexos</h4>
      <v-layout row wrap>
        <v-flex xs12 md5 class="px-1">
          <v-select
            label="Tipo Anexo"
            item-text="descricao"
            item-value="id"
            v-model="tipoAnexo"
            :clearable="true"
            :items="dmTiposAnexos"
          ></v-select>
          <label
            >Extensões permitidas:
            .zip,.pdf,.csv,.xls,.odt,.doc,.docx,.txt,.png,.jpg,.jpeg.
          </label>
        </v-flex>
        <v-flex xs12 md4 class="px-1">
          <v-layout row>
            <v-text-field
              disabled
              label="Arquivo"
              name="filename"
              type="text"
              v-model="arquivoAnexo"
            ></v-text-field>
            <v-btn
              flat
              icon
              color="grey darken-2"
              class="body-2 text-none"
              @click="$refs.file.click()"
            >
              <v-icon>attach_file</v-icon>
            </v-btn>
            <input
              type="file"
              ref="file"
              style="display: none"
              @change="uploadAnexo"
            />
          </v-layout>
        </v-flex>
        <v-flex xs12 md3 class="px-1">
          <v-btn
            light
            small
            :disabled="!tipoAnexo || !arquivoAnexo"
            :color="highContrast ? 'white' : 'primary'"
            @click="adicionarAnexo()"
            >Adicionar</v-btn
          >
        </v-flex>
      </v-layout>
      <v-list two-line v-if="movimentoAnexos">
        <template v-for="(item, index) in movimentoAnexos">
          <v-list-tile :key="item.id" ripple>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.anexo.filename }}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{
                item.tipoAnexo.descricao
              }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon @click="removerAnexo(index)"> delete </v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < anexos.length" :key="index"></v-divider>
        </template>
      </v-list>
    </v-layout>
    <v-layout row justify-end>
      <v-btn flat @click="cancelar()">Cancelar</v-btn>
      <v-btn color="primary" @click="gerarSegundaVia()">Concluir</v-btn>
    </v-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import MensagemAnexo from "@/components/MensagemAnexo";

import {
  cadastrarAnexo,
  listarMovimentoAnexos,
  listarTiposAnexo,
  removerAnexo
} from "@/services/movimentos";

const { mapState } = createNamespacedHelpers("portal");

export default {
  name: "EtapaAnexosSegundaVia",
  props: {
    loading: Boolean,
    movimentoId: Number
  },
  components: {
    MensagemAnexo
  },
  computed: {
    ...mapState(["highContrast"])
  },
  watch: {
    movimentoId: {
      handler() {
        this.limparDadosMovimento();
      }
    }
  },
  data() {
    return {
      anexos: [],
      arquivoAnexo: null,
      dmTiposAnexos: null,
      file: null,
      movimentoAnexos: null,
      parametroMensagemAnexo: 2,
      tipoAnexo: null
    };
  },
  created() {
    this.listarMovimentoAnexos();
    this.tiposAnexos();
  },
  methods: {
    adicionarAnexo() {
      this.$emit("altera-loading", true);

      let data = new FormData();
      data.append("arquivo", this.file);
      data.append("tipoAnexoId", this.movimentoId);
      data.append("movimentoId", this.tipoAnexo);

      cadastrarAnexo(this.tipoAnexo, this.movimentoId, data)
        .then(async () => {
          this.tipoAnexo = null;
          await this.listarMovimentoAnexos();
        })
        .finally(() => {
          this.$emit("altera-loading", false);
        });
    },
    cancelar() {
      this.limparDadosMovimento();
      this.$emit("cancelar");
    },
    gerarSegundaVia() {
      this.$emit("gerar-segunda-via");
    },
    limparDadosMovimento() {
      this.anexos = [];
      this.arquivoAnexo = null;
      this.file = null;
      this.movimentoAnexos = null;
      this.tipoAnexo = null;
    },
    async listarMovimentoAnexos() {
      if (this.movimentoId) {
        await listarMovimentoAnexos(this.movimentoId).then(response => {
          this.movimentoAnexos = response;
        });
      }
    },
    removerAnexo(index) {
      this.$emit("altera-loading", true);

      const movimentoArquivoId = this.movimentoAnexos[index].anexo.arquivoId;
      removerAnexo(movimentoArquivoId)
        .then(() => {
          this.movimentoAnexos.splice(index, 1);
        })
        .finally(() => {
          this.$emit("altera-loading", false);
        });
    },
    async tiposAnexos() {
      await listarTiposAnexo().then(response => {
        this.dmTiposAnexos = response;
      });
    },
    uploadAnexo(element) {
      this.file = element.target.files[0];
      this.arquivoAnexo = this.file.name;
    }
  }
};
</script>
